import { Debouncer, getAllParentNodes } from '../../libraries/common';
import Vue from '../../vue';

Vue.directive('horizontal-scroll', {
  inserted: el => {
    var div = document.createElement('div');
    div.className = "overflow-x bottom-scroll-bar";

    var innerDiv = document.createElement('div');
    div.appendChild(innerDiv);
    el.appendChild(div)

    el.calculateStyles = () => {
      div.style = `width: ${window.innerWidth}px;`;
      var innerDivWidth = el.scrollWidth / el.offsetWidth * window.innerWidth;
      innerDiv.style = `width: ${innerDivWidth}px; height: 1px;`;
    };
    var count = 0;
    var isResizing = false;
    el.onResize = () => {
      const onResize = () => {
        var value = div.scrollLeft / el.offsetWidth * window.innerWidth;
        el.scrollLeft = value;

        if (count < 5)
          requestAnimationFrame(onResize);
        else
          isResizing = false;

        count++;
      };

      count = 0;
      isResizing = true;
      requestAnimationFrame(onResize);
    }
    var isElScrolling = false;
    var isDivScrolling = false;
    var divScrollDebouncer = new Debouncer(50);
    div.addEventListener('scroll', () => {
      if (!isElScrolling) {
        var value = div.scrollLeft * el.offsetWidth / window.innerWidth;
        isDivScrolling = true;
        if (Math.abs(el.scrollLeft - value) > 1)
          el.scrollLeft = value;

        divScrollDebouncer.clear().push(() => isDivScrolling = false);
      }
    });
    var elScrollDebouncer = new Debouncer(50);
    el.addEventListener('scroll', () => {
      if (!isResizing && !isDivScrolling) {
        isElScrolling = true;
        var value = el.scrollLeft / el.offsetWidth * window.innerWidth;
        if (Math.abs(div.scrollLeft - value) > 1)
          div.scrollLeft = value;

        elScrollDebouncer.clear().push(() => isElScrolling = false);
      }
    });

    [...new Array(20).keys()]
      .forEach(f => setTimeout(el.calculateStyles, f * 200));

    window.addEventListener('resize', el.calculateStyles);
    window.addEventListener('resize', el.onResize);

    el.onParentScroll = () => {
      var showScrollBar = el.getBoundingClientRect().bottom > window.innerHeight;
      if (showScrollBar === div.classList.contains('no-show'))
        div.classList.toggle('no-show');
    }
    getAllParentNodes(el)
      .concat(document)
      .forEach(f => f.addEventListener('scroll', el.onParentScroll));
  },
  unbind: el => {
    window.removeEventListener('resize', el.calculateStyles);
    window.removeEventListener('resize', el.onResize);
    getAllParentNodes(el)
      .concat(document)
      .forEach(f => f.removeEventListener('scroll', el.onParentScroll));
  },
});